import { FormControl, FormGroup } from '@angular/forms';
import { STATUS_OPTIONS } from 'src/app/components/shared/shared-constants';

export const CONSTS = {
  HEADER: $localize`COD Reconcile`,
  ROUTE_LABEL: $localize`Route`,
  ROUTE_LABEL_PLACEHOLDER: $localize`Select Route`,
  ROUTE_ALL: STATUS_OPTIONS.ALL_SELECTED,
};

export const FILE_NAME = 'COD-Reconcile';

export const MOCK_COD_RECONCILE_ROUTES = {
  response: {
    CODReconcileRoutes: [{ route: '1' }],
  },
};

export const MOCK_COD_RECONCILE = {
  response: {
    codReconcile: [
      {
        stopId: 1119116183,
        position: 0,
        stopDate: '06-28-2023',
        trackingNo: '1Z1271220206286448',
        loop: '001',
        locationCode: 'DEBIN',
        shipper: '127122',
        pmntAmount: 52,
        pmntCurrency: 'EUR',
        pmntType: 'CHEQUE',
        stopType: 'D',
        codTurninAmount: 52,
        codTurninCurrency: 'EUR',
        codTurninDate: '04-AUG-2023', // SYSTEM date when the turnin check box is checked and submit
        codTurninComments: 'TESTING',
      },
      {
        stopId: 1123686485,
        position: 1,
        stopDate: '07-14-2023',
        trackingNo: '1Z1271220207126734',
        loop: '03B',
        locationCode: 'DEBIN',
        shipper: '127122',
        pmntAmount: 84,
        pmntCurrency: 'EUR',
        pmntType: 'CHEQUE',
        stopType: 'D',
        codTurninAmount: 84,
        codTurninCurrency: 'EUR',
        codTurninDate: '04-AUG-2023', // SYSTEM date when the turnin check box is checked and submit
        codTurninComments: 'TEST',
      },
    ],
  },
};

type ReconcileFormField = {
  routes: FormControl<string>;
};

export type ReconcileFormGroup = FormGroup<ReconcileFormField> | null;
